import Alerts from 'Core/components/Alerts/AlertsAdministration';
import AlertsEntry from 'Core/components/Alerts/AlertsEntry';
import NotAuthorized from 'Core/components/NotAuthorized';
import LegalAcceptance from 'Core/components/TermsAndConditions/LegalAcceptance';
import LegalDocument from 'Core/components/TermsAndConditions/LegalDocument';
import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {UserClaims} from 'Users/models/Claims';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import useOnNavigateAway from 'Shared/utilities/useOnNavigateAway';
import {clearAlertsFilter} from 'Core/ducks/alerts';
import {useDispatch} from 'react-redux';
import LineOfBusinessDashboard from './components/Dashboard/LineOfBusinessDashboard';
import AgentDashboard from './components/Dashboard/AgentDashboard';
import PortalDashboard from './components/Dashboard/PortalDashboard';
import {fromResult} from './models/Async';

type CoreRouteProps = {
  claims: UserClaims;
};

export const AlertRoutes = () => {
  const dispatch = useDispatch();
  useBreadcrumbs('Alerts Administration', CoreRouteConstants.ALERTS);
  useOnNavigateAway(CoreRouteConstants.ALERTS, () => {
    dispatch(clearAlertsFilter());
  });

  return (
    <Switch>
      <Route path="/alerts/add" render={() => <AlertsEntry />} />,
      <Route path="/alerts/edit/:alertId" render={() => <AlertsEntry />} />,
      <Route path="/alerts" render={() => <Alerts />} />,
    </Switch>
  );
};

export default ({claims}: CoreRouteProps) => {
  return (
    <Route
      path={'/'}
      render={() => (
        <Switch>
          <Route exact path="/" render={() => <LineOfBusinessDashboard userClaims={fromResult(claims)} />} />
          <Route exact path="/portal/portalDashboard" render={() => <PortalDashboard />} />
          <Route exact path="/agent/agentDashboard" render={() => <AgentDashboard />} />
          <Route path="/alerts" render={() => <AlertRoutes />} />
          <Route path="/legal" render={() => <LegalDocument />} />
          <Route path="/legalAgreements" render={() => <LegalAcceptance />} />,
          <Route path="/unauthorized" render={() => <NotAuthorized claims={claims} />} />
        </Switch>
      )}
    />
  );
};
